import React, { useState } from "react";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  expandIcon: {
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandIconOpen: {
    transform: 'rotate(180deg)',
  },
}));

export default function LogInformation(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  if (!props || 
     !props.Anmodning ||
     !props.Anmodning.system_actions ) {
    return (<div></div>);
  }
    
  function getLog() {
      return props.Anmodning.system_actions;
  }
  function getLogLength() {
    return props.Anmodning.system_actions.length;
  }

  const handleToggle = () => {
    setOpen(!open);
  };

  return (

    <div>
      <div className={classes.header} onClick={handleToggle}>
        <span>Log Information ({getLogLength()} logs)</span>
        <IconButton
          className={`${classes.expandIcon} ${open ? classes.expandIconOpen : ''}`}
          size="small"
        >
          <ExpandMoreIcon />
        </IconButton>
      </div>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Action</TableCell>
              <TableCell>Timestamp </TableCell>
              <TableCell align="left">Subject</TableCell>
              <TableCell align="left">Message</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {getLog().map(row => (
              <TableRow key={row.message_id}>
                <TableCell align="left" component="th" scope="row">{row.action} </TableCell>
                <TableCell align="left">{row.timestamp}</TableCell>
                <TableCell align="left">{row.subject}</TableCell>
                <TableCell align="left">{row.message}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Collapse>
    </div>

  );
}